import { Component, OnDestroy, OnInit, HostListener, ViewChild, ElementRef } from "@angular/core";
import { DialogComponent, DialogService } from "ngx-bootstrap-modal";
import { HttpClient } from '@angular/common/http';
import { Router } from "@angular/router";

import { CommonConst } from "../shared/const/common-const";
import { DialogYesComponent } from "../shared/component/dialog-yes/dialog-yes.component";
import { MessageUtil } from "../shared/utility/message-util";
import { GaUtil } from '../shared/utility/ga-util';
import { ValidationUtil } from "../shared/utility/validation-util";
import { N201A04OutShohinrisutoData } from "../shared/webapi-data/n201a04-out-shohinrisuto-data";
import { N2014Component } from "./n2014.component";
import { N201SessionStorageKey } from "./n201-session-storage-key";
import { N2013InputData } from "./n2013-input-data";
import { N2013OutputData } from "./n2013-output-data";
import { RedirectUtil } from "../shared/utility/redirect-util";
import { CommonStorageKey } from "../shared";
declare var $: any;

export interface DialogModel {
  item: any;
  name: any;
  otodokesakukubun: any;
  okurisaki: any;
  yubimbango: any;
  kenkodo: any;
  jusho: any;
  shohinkubun: any;
  elementId: any;
  meisaiCnt: any;
}

@Component({
  selector: 'app-n2013',
  templateUrl: './n2013.component.html',
  styleUrls: ['./n2013.component.css']
})
export class N2013Component extends DialogComponent<DialogModel, boolean> implements DialogModel, OnInit, OnDestroy {
  @ViewChild('btnHatchuYoteiListEr') btnHatchuYoteiListEr: ElementRef;
  @ViewChild('cancelEr') cancelEr: ElementRef;

  item: any;
  name: any;
  otodokesakukubun: any;
  okurisaki: any;
  yubimbango: any;
  kenkodo: any;
  jusho: any;
  shohinkubun: any;
  elementId: any;
  meisaiCnt: any;

  // 一覧
  public inputData = new N2013InputData();
  public outputData = new N2013OutputData();
  public detailData: N201A04OutShohinrisutoData[] = [];
  public detailDataTmp: N201A04OutShohinrisutoData[] = [];
  //発注予定リスト
  public hatchuYoteiList: N201A04OutShohinrisutoData[] = [];
  // 重クリック防止
  public isLoading: boolean;
  // グループ区分権限判定フラグ
  public gurupukubunKengenFlg: boolean = true;
  // ST-102 Start
  public disabledFlg: boolean = false;
  // ST-102 End
  //チェックされた関連部材を順番に記憶するリスト
  public checkKanrenBuzaiList: number[] = [];

  constructor(dialogService: DialogService,
    private http: HttpClient,
    private router: Router) {
    super(dialogService);
  }

  ngOnInit() {
    // 背面の固定
    $('body').css('overflow-y', 'hidden'); // 強化テストNo245

    // ST-102 Start
    if (sessionStorage.getItem(CommonStorageKey.GAMENID) == CommonConst.PGM_N2011) {
      this.disabledFlg = true;    // 非表示
    } else {
      this.disabledFlg = false;   // 表示
      // 強化テストNo312 start
      // 幅を自動調整とするため以下は不要
       // document.getElementById('mainBox').style.width = '720px';
      // 強化テストNo312 end
    }
    // ST-102 End
    // グループ区分権限判定(一次店、二次店以外は引用発注は不可)
    // ST-190 Start
    const isHasKengenFlg = sessionStorage.getItem(N201SessionStorageKey.N201GurupukubunKengenFlg);
    if (isHasKengenFlg === 'false') {     
      this.gurupukubunKengenFlg = false;
    }
    // ST-190 End
    sessionStorage.setItem(N201SessionStorageKey.N202HatchuData, '');
    this.inputData.himban = this.item;
    const otodokesakukubun = sessionStorage.getItem(N201SessionStorageKey.N2013Otodokesakukubun);
    if (!ValidationUtil.isEmpty(otodokesakukubun)) {
      this.inputData.otodokesakikubun = otodokesakukubun;
      sessionStorage.setItem(N201SessionStorageKey.N2013Otodokesakukubun, '');
    } else {
      this.inputData.otodokesakikubun = this.otodokesakukubun;
    }

    const okurisaki = sessionStorage.getItem(N201SessionStorageKey.N2013Okurisaki);
    if (!ValidationUtil.isEmpty(okurisaki)) {
      this.inputData.okurisaki = okurisaki;
      sessionStorage.setItem(N201SessionStorageKey.N2013Okurisaki, '');
    } else {
      this.inputData.okurisaki = this.okurisaki;
    }

    const yubimbango = sessionStorage.getItem(N201SessionStorageKey.N2013Yubimbango);
    if (!ValidationUtil.isEmpty(yubimbango)) {
      this.inputData.yubimbango = yubimbango;
      sessionStorage.setItem(N201SessionStorageKey.N2013Yubimbango, '');
    } else {
      this.inputData.yubimbango = this.yubimbango;
    }

    const kenkodo = sessionStorage.getItem(N201SessionStorageKey.N2013Todofuken);
    if (!ValidationUtil.isEmpty(kenkodo)) {
      this.inputData.todofuken = kenkodo;
      sessionStorage.setItem(N201SessionStorageKey.N2013Todofuken, '');
    } else {
      this.inputData.todofuken = this.todofuken;
    }

    const jusho = sessionStorage.getItem(N201SessionStorageKey.N2013Jusho);
    if (!ValidationUtil.isEmpty(jusho)) {
      this.inputData.jusho = jusho;
      sessionStorage.setItem(N201SessionStorageKey.N2013Jusho, '');
    } else {
      this.inputData.jusho = this.jusho;
    }
    const shohinkubun = sessionStorage.getItem(N201SessionStorageKey.N2013Shohinkubun);
    if (!ValidationUtil.isEmpty(shohinkubun)) {
      this.inputData.syouhinnKbn = shohinkubun;
      sessionStorage.setItem(N201SessionStorageKey.N2013Shohinkubun, '');
    } else {
      this.inputData.syouhinnKbn = this.shohinkubun;
    }

    document.body.style.cursor = 'wait';
    this.inputData.uniqueId = sessionStorage.getItem(CommonStorageKey.UNIQUEID);
    this.http.post<N2013OutputData>('/InitialN2013', this.inputData).subscribe(result => {
      // 非稼働の場合、メンテナンス画面に遷移する
      if (RedirectUtil.toMaintenance(result, this.router)) {
        this.close();
        return;
      }
      this.outputData = result[0];
      if (this.outputData.rtnCode == CommonConst.C_RTN_CODE_OK) {
        let tempDetailData: N201A04OutShohinrisutoData[] = [];
        sessionStorage.setItem(N201SessionStorageKey.N202HatchuData, '');
        // セッションストレージの「関連部材」情報
        const hatchuData = sessionStorage.getItem(N201SessionStorageKey.N2013HatchuData);
        if (!ValidationUtil.isEmpty(hatchuData)) {
          tempDetailData = JSON.parse(hatchuData);
          sessionStorage.setItem(N201SessionStorageKey.N2013HatchuData, '');
        } else {
          tempDetailData = this.outputData.apiOutData.shohinrisuto;
        }

        for (let i = 0; i < tempDetailData.length; i++) {
          // ST-243 Start
          // 対象外判定
          if (tempDetailData[i].zaikokubunmei === "対象外") {
            tempDetailData[i].suryo = 0;
            tempDetailData[i].saiTanKyoTen = 'お問い合わせください';
            //tempDetailData[i].saiTanKyoTen = tempDetailData[i].suryo.toString() + tempDetailData[i].shohintani1mei + '\nお問い合わせください';
            tempDetailData[i].disabledFlg = true;

            // チェックボックスを非活性とする。
            tempDetailData[i].chbDisabledFlg = true;
          } else {
            if (tempDetailData[i].suryo === 0) {
              tempDetailData[i].disabledFlg = true;
              tempDetailData[i].saiTanKyoTen = tempDetailData[i].suryo.toString() + tempDetailData[i].shohintani1mei + '\nお問い合わせください';
            } else {
              tempDetailData[i].disabledFlg = false;
              tempDetailData[i].saiTanKyoTen = tempDetailData[i].sokomei + '：' + this.numFormat(tempDetailData[i].suryo.toString()) + tempDetailData[i].shohintani1mei + '\n';
              if (!ValidationUtil.isEmpty(tempDetailData[i].otodokeyoteibi)) {
                if (tempDetailData[i].otodokeyoteibi.length === 8) {
                  tempDetailData[i].saiTanKyoTen = tempDetailData[i].saiTanKyoTen + tempDetailData[i].otodokeyoteibi.substr(0, 4) + '/' +
                    tempDetailData[i].otodokeyoteibi.substr(4, 2) + '/' + tempDetailData[i].otodokeyoteibi.substr(6, 2);
                } else {
                  tempDetailData[i].saiTanKyoTen = tempDetailData[i].saiTanKyoTen + tempDetailData[i].otodokeyoteibi;
                }
              }
            }
            // チェックボックスを活性とする。
            tempDetailData[i].chbDisabledFlg = false;
          // ST-243 End
          }
        }

        // ST-243 Start
        this.detailDataTmp = [];
        for (let i = 0; i < tempDetailData.length; i++) {
          if (i < tempDetailData.length - 1) {
            if (tempDetailData[i].zaikokubunmei != "対象外") {
              if (tempDetailData[i].suryo == 0) {
                if (tempDetailData[i].himban == tempDetailData[i + 1].himban) {
                  continue;
                }
                else {
                  this.detailDataTmp.push(tempDetailData[i]);
                }
              }
              else {
                this.detailDataTmp.push(tempDetailData[i]);
              }
            }
            else {
              this.detailDataTmp.push(tempDetailData[i]);
            }
          }
          else {
            this.detailDataTmp.push(tempDetailData[i]);
          }
        }
        // ST-243 End

        // ST-243 Start
        this.detailData = [];
        let tempHimban: string = '';
        let saiTanKyoTen: string = '';
        let updateFlg: boolean = true;
        for (let i = 0; i < this.detailDataTmp.length; i++) {
          if (i === 0) {
            tempHimban = this.detailDataTmp[i].himban;
            saiTanKyoTen = this.detailDataTmp[i].saiTanKyoTen;
            this.detailData.push(this.detailDataTmp[i]);
            continue;
          }
          if (tempHimban === this.detailDataTmp[i].himban) {
            // 数量が0の場合、受注生産品となり、2行目を表示する必要がありません。
            if (this.detailDataTmp[i].suryo === 0) {
              continue;
            }
            if (updateFlg === true) {
              saiTanKyoTen = saiTanKyoTen + '\n' + this.detailDataTmp[i].saiTanKyoTen;
              this.detailData[this.detailData.length - 1].saiTanKyoTen = saiTanKyoTen;
              updateFlg = false;
            }
            tempHimban = this.detailDataTmp[i].himban;
            continue;
          } else {
            updateFlg = true;
            this.detailData.push(this.detailDataTmp[i]);
            tempHimban = this.detailDataTmp[i].himban;
            saiTanKyoTen = this.detailDataTmp[i].saiTanKyoTen;
          }
        }
        // ST-243 End
        setTimeout(() => {
          let setOkFlg: boolean = false;
          for (let i = 0; i < this.detailData.length; i++) {
            if (this.detailData[i].chbDisabledFlg === false) {
              let id = 'checkSubFlg' + i;
              document.getElementById(id).focus();
              setOkFlg = true;
              break;
            }
            else {
              if (this.detailData[i].disabledFlg === false) {
                let id = 'zaikoDialog' + i;
                document.getElementById(id).focus();
                setOkFlg = true;
                break;
              }
            }
          }
          if (!setOkFlg) {
            document.getElementById('btnHatchuYoteiListEr').focus();
          }
        }, 10);
        
      } else if (this.outputData.rtnCode == CommonConst.C_RTN_CODE_NG) {
        this.dialogService.addDialog(DialogYesComponent, { message: MessageUtil.getStorageMessage(this.outputData.messageId) }
        ).subscribe((isOk) => { });
      } else if (this.outputData.rtnCode == CommonConst.C_RTN_CODE_API_NG3 || this.outputData.rtnCode == CommonConst.C_RTN_CODE_API_NG4) {
        this.dialogService.addDialog(DialogYesComponent, { message: this.outputData.apiOutData.messejihombun }
        ).subscribe((isOk) => { });
      } else {
        this.router.navigateByUrl('/ne01', { skipLocationChange: true });
      }
    }, error => this.router.navigateByUrl('/ne01', { skipLocationChange: true }), () => { document.body.style.cursor = 'default'; });
  }

  /**
   * 在庫詳細連動
   * @param index
   */
  zaikoShosai(index) {
    let item = this.detailData[index].himban;
    let name = this.detailData[index].shohimmeisho;
    let otodokesakukubun = this.inputData.otodokesakikubun;
    let okurisaki = this.inputData.okurisaki;
    let yubimbango = this.inputData.yubimbango;
    let kenkodo = this.inputData.todofuken;
    let jusho = this.inputData.jusho;
    let shohinkubun = this.inputData.syouhinnKbn;
    this.dialogService.addDialog(N2014Component, {
      item: item, name: name,
      otodokesakukubun: otodokesakukubun,
      okurisaki: okurisaki,
      yubimbango: yubimbango,
      kenkodo: kenkodo,
      jusho: jusho,
      shohinkubun: shohinkubun,
      elementId: 'zaikoDialog' + index
    }
    ).subscribe((isOk) => { });
  }

  cancel() {
    this.close(true);
    setTimeout(() => {
      document.getElementById(this.elementId).focus();
    }, 200);
  }

  ngOnDestroy() {

    // 背面の固定解除
    $('body').css('overflow-y', 'scroll'); // 強化テストNo245

    this.close(false);
    setTimeout(() => {
      document.getElementById(this.elementId).focus();
    }, 200);
  }

  /** 
  * チェックした順番を記憶する
 */
  checkKanrenBuzai(index) {
    if (!this.checkKanrenBuzaiList.includes(index)) {
      this.checkKanrenBuzaiList.push(index);
    } else {
      this.checkKanrenBuzaiList.splice(this.checkKanrenBuzaiList.indexOf(index), 1);
    }
  }

  /**
 * 発注予定リストに入れる
*/
  btnHatchuYoteiList() {
    // 選択有無チェック
    let selectFlg = false;
    for (let i = 0; i < this.detailData.length; i++) {
      const checkFlg = <HTMLInputElement>document.getElementById('checkSubFlg' + i);
      if (checkFlg.checked) {
        selectFlg = true;
        break;
      }
    }
    if (!selectFlg) {
      this.dialogService.addDialog(DialogYesComponent, { message: MessageUtil.getStorageMessage('N201302'), elementId:'btnHatchuYoteiListEr'}
      ).subscribe((isOk) => { });
      return;
    }

    const hatchuYoteiList = sessionStorage.getItem(N201SessionStorageKey.N202HatchuYoteiList);
    if (ValidationUtil.isEmpty(hatchuYoteiList)) {
      this.hatchuYoteiList = [];
    } else {
      this.hatchuYoteiList = JSON.parse(hatchuYoteiList);
    }

    const hatchuData: N201A04OutShohinrisutoData[] = [];
    //チェックした順に発注予定リストに追加する
    for (let i = 0; i < this.checkKanrenBuzaiList.length; i++) {
      const checkFlg = <HTMLInputElement>document.getElementById('checkSubFlg' + this.checkKanrenBuzaiList[i]);
      if (checkFlg.checked) {
        // 発注予定リストの同じ品番が複数登録できる。
        let himbanFlg: boolean = false;
        //強化テスト2020/03/24 No.7 start
        //for (let j = 0; j < this.hatchuYoteiList.length; j++) {
        //  // 同じ品番を判断
        //  if (this.hatchuYoteiList[j].himban === this.detailData[i].himban) {
        //    // 同じ品番
        //    himbanFlg = true;
        //    break;
        //  }
        //}
        //強化テスト2020/03/24 No.7 end
        if (!himbanFlg) {
          this.hatchuYoteiList.push(this.detailData[this.checkKanrenBuzaiList[i]]);

          // 強化テスト No.283 Start
          //if (this.hatchuYoteiList.length > 20) {
          if (this.hatchuYoteiList.length + this.meisaiCnt > 20) {
            let messageid: string;
            if (this.disabledFlg) {
              messageid = 'N201301';
            } else {
              messageid = 'N202101';
            }
          // 強化テスト No.283 End
            // 発注予定リストの件数が20件の場合
            this.dialogService.addDialog(DialogYesComponent, { message: MessageUtil.getStorageMessage(messageid), elementId: 'btnHatchuYoteiListEr' }
            ).subscribe((isOk) => { });
            return;
          }
        }
        // 発注商品入力リストに追加
        hatchuData.push(this.detailData[i]);
      }
    }
    for (let j = 0; j < this.detailData.length; j++) {
      // チェックボックス解除
      const allCheck = <HTMLInputElement>document.getElementById('checkSubFlg' + j);
      if (!ValidationUtil.isEmpty(allCheck)) {
        allCheck.checked = false;

        const suryo = <HTMLInputElement>document.getElementById('strchumonsuryo' + j);
        if (!ValidationUtil.isEmpty(suryo)) {
           suryo.value = ""
        }
      }

      // チェックボックスの値を設定
      this.detailData[j].flg = '';
    }
    sessionStorage.setItem(N201SessionStorageKey.N202HatchuData, JSON.stringify(hatchuData));
    // セッションストレージ情報の「発注予定リスト」に入れる
    sessionStorage.setItem(N201SessionStorageKey.N202HatchuYoteiList, JSON.stringify(this.hatchuYoteiList));
    GaUtil.traceEvent_EachGroupCd('商品・在庫照会 発注予定リストに入れる（選択）', '');

    //画面を閉じる
    this.cancel();
  }

  numFormat(value: string): string {
    if (!ValidationUtil.isEmpty(value)) {
      const length = value.length;
      for (let i = 1; i < length / 3; i++) {
        const temp = value.slice(0, -4 * i + 1);
        value = value.replace(temp, temp + ',');
      }
    }
    return value;
  }

  @HostListener('window:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    // Tabキーと十字キー(→↓)の場合
    if ((event.keyCode == 9 && !event.shiftKey) || event.keyCode == 39 || event.keyCode == 40) {　// 強化テストNo247
      if (document.activeElement.id == 'btnHatchuYoteiListEr') {
        document.getElementById('cancelEr').focus();
      } else if (document.activeElement.id == 'cancelEr' || document.activeElement.id == '') {
        let setOkFlg: boolean = false;
        for (let i = 0; i < this.detailData.length; i++) {
          if (this.detailData[i].chbDisabledFlg === false) {
            let id = 'checkSubFlg' + i;
            document.getElementById(id).focus();
            setOkFlg = true;
            break;
          }
          else {
            if (this.detailData[i].disabledFlg === false) {
              let id = 'zaikoDialog' + i;
              document.getElementById(id).focus();
              setOkFlg = true;
              break;
            }
          }
        }
        if (!setOkFlg) {
          document.getElementById('btnHatchuYoteiListEr').focus();
        }
      } else if (document.activeElement.id.substr(0, 11) == 'checkSubFlg') {
        let setOkFlg: boolean = false;
        for (let i = parseInt(document.activeElement.id.substring(11)); i < this.detailData.length; i++) {
          if (i === parseInt(document.activeElement.id.substring(11))) {
            if (this.detailData[i].disabledFlg === false) {
              let id = 'zaikoDialog' + i;
              document.getElementById(id).focus();
              setOkFlg = true;
              break;
            }
            else {
              if (this.disabledFlg === false && this.gurupukubunKengenFlg === true) {
                let id = 'strchumonsuryo' + i;
                document.getElementById(id).focus();
                setOkFlg = true;
                break;
              }
            }
          }
          else {
            if (this.detailData[i].chbDisabledFlg === false) {
              let id = 'checkSubFlg' + i;
              document.getElementById(id).focus();
              setOkFlg = true;
              break;
            }
            else {
              if (this.detailData[i].disabledFlg === false) {
                let id = 'zaikoDialog' + i;
                document.getElementById(id).focus();
                setOkFlg = true;
                break;
              }
            }
          }
        }
        if (!setOkFlg) {
          document.getElementById('btnHatchuYoteiListEr').focus();
        }
      } else if (document.activeElement.id.substr(0, 11) == 'zaikoDialog') {
        let setOkFlg: boolean = false;
        for (let i = parseInt(document.activeElement.id.substring(11)) + 1; i < this.detailData.length; i++) {
          if (this.detailData[i].chbDisabledFlg === false) {
            let id = 'checkSubFlg' + i;
            document.getElementById(id).focus();
            setOkFlg = true;
            break;
          }
          else {
            if (this.detailData[i].disabledFlg === false) {
              let id = 'zaikoDialog' + i;
              document.getElementById(id).focus();
              setOkFlg = true;
              break;
            }
          }
        }
        if (!setOkFlg) {
          document.getElementById('btnHatchuYoteiListEr').focus();
        }
      } else if (document.activeElement.id.substr(0, 14) == 'strchumonsuryo') {
        let setOkFlg: boolean = false;
        for (let i = parseInt(document.activeElement.id.substring(14)); i < this.detailData.length; i++) {
          if (i === parseInt(document.activeElement.id.substring(14))) {
            if (this.detailData[i].disabledFlg === false) {
              let id = 'zaikoDialog' + i;
              document.getElementById(id).focus();
              setOkFlg = true;
              break;
            }
          }
          else {
            if (this.detailData[i].chbDisabledFlg === false) {
              let id = 'checkSubFlg' + i;
              document.getElementById(id).focus();
              setOkFlg = true;
              break;
            }
            else {
              if (this.detailData[i].disabledFlg === false) {
                let id = 'zaikoDialog' + i;
                document.getElementById(id).focus();
                setOkFlg = true;
                break;
              }
            }
          }
        }
        if (!setOkFlg) {
          document.getElementById('btnHatchuYoteiListEr').focus();
        }
      }
      return false;
    }
    // 十字キー(←↑)の場合
    if (event.keyCode == 37 || event.keyCode == 38 || (event.keyCode == 9 && event.shiftKey)) {　// 強化テストNo247
      if (document.activeElement.id == 'cancelEr') {
        document.getElementById('btnHatchuYoteiListEr').focus();
      } else if (document.activeElement.id == 'btnHatchuYoteiListEr') {
        let setOkFlg: boolean = false;
        for (let i = this.detailData.length - 1; i >= 0; i--) {
          if (this.detailData[i].disabledFlg === false) {
            let id = 'zaikoDialog' + i;
            document.getElementById(id).focus();
            setOkFlg = true;
            break;
          }
          else {
            if (this.detailData[i].chbDisabledFlg === false) {
              if (this.disabledFlg === false && this.gurupukubunKengenFlg === true) {
                let id = 'strchumonsuryo' + i;
                document.getElementById(id).focus();
                setOkFlg = true;
                break;
              }
              else {
                let id = 'checkSubFlg' + i;
                document.getElementById(id).focus();
                setOkFlg = true;
                break;
              }
            }
          }
        }
        if (!setOkFlg) {
          document.getElementById('cancelEr').focus();
        }

      } else if (document.activeElement.id.substr(0, 11) == 'zaikoDialog') {
        let setOkFlg: boolean = false;
        for (let i = parseInt(document.activeElement.id.substring(11)); i >= 0; i--) {
          if (this.detailData[i].chbDisabledFlg === false) {
            let id = 'checkSubFlg' + i;
            document.getElementById(id).focus();
            setOkFlg = true;
            break;
          }
          else {
            if (this.detailData[i].disabledFlg === false) {
              let id = 'zaikoDialog' + i;
              document.getElementById(id).focus();
              setOkFlg = true;
              break;
            }
            else {
              if (this.detailData[i].disabledFlg === false) {
                let id = 'checkSubFlg' + i;
                document.getElementById(id).focus();
                setOkFlg = true;
                break;
              }
            }
          }
        }
        if (!setOkFlg) {
          document.getElementById('cancelEr').focus();
        }
      } else if (document.activeElement.id.substr(0, 11) == 'checkSubFlg') {
        let setOkFlg: boolean = false;
        for (let i = parseInt(document.activeElement.id.substring(11)) - 1; i >= 0; i--) {
          if (this.detailData[i].disabledFlg === false) {
            let id = 'zaikoDialog' + i;
            document.getElementById(id).focus();
            setOkFlg = true;
            break;
          }
          else {
            if (this.detailData[i].chbDisabledFlg === false) {
              if (this.disabledFlg === false && this.gurupukubunKengenFlg === true) {
                let id = 'strchumonsuryo' + i;
                document.getElementById(id).focus();
                setOkFlg = true;
                break;
              }
              else {
                let id = 'checkSubFlg' + i;
                document.getElementById(id).focus();
                setOkFlg = true;
                break;
              }
            }
          }
        }
        if (!setOkFlg) {
          document.getElementById('cancelEr').focus();
        }
      } else if (document.activeElement.id.substr(0, 14) == 'strchumonsuryo') {
        let setOkFlg: boolean = false;
        for (let i = parseInt(document.activeElement.id.substring(14)); i >= 0; i--) {
          if (this.detailData[i].disabledFlg === false) {
            let id = 'zaikoDialog' + i;
            document.getElementById(id).focus();
            setOkFlg = true;
            break;
          }
          else {
            if (this.detailData[i].chbDisabledFlg === false) {
              let id = 'checkSubFlg' + i;
              document.getElementById(id).focus();
              setOkFlg = true;
              break;
            }
          }
        }
        if (!setOkFlg) {
          document.getElementById('cancelEr').focus();
        }
      }
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/n201/n2013.component.ts